// Time formatting for date-fns

export const dateDashes = 'y-MM-dd' // 2022-01-05
export const dateSlashes = 'M/d/y' // 3/3/2022
export const dateSlashesShortYear = 'M/d/yy' // 3/3/22
export const time12hr = 'h:mm aa' // 2:23 pm
export const dateAndTime = `y-MM-dd HH:mm:ss` // 2022-01-05 05:12
export const dateAndTime12hr = `y-MM-dd, h:mm aa` // 2022-01-05 5:12 PM
export const dateAndTimeSlashes = 'MM/dd/y HH:mm' // '01/05/2022 14:00'
export const dateAndTimeSlashes12hr = 'M/d/y h:mm aa' // '1/5/2022 8:00 PM'
export const verbalDateAndTimeAt = `MMM d, y 'at' h:mm aaa` // Jan 24, 2022 at 7:23 pm
export const verbalDateAndTime = `MMM d, y h:mm aaa` // Jan 24, 2022 7:23 pm
export const dateAndTimeForFiles = `y-MM-dd_HH:mm:ss` // 2022-01-05 05:12
